import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function HEV_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <HEV_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <HEV_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function HEV_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What kind of projects are common in the HEV field?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Projects include battery management systems, powertrain optimization, energy recovery through regenerative braking, and eco-friendly vehicle design.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How are HEVs different from fully electric vehicles (EVs)? 
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              HEVs use both a gasoline engine and electric motor, while EVs run only on electricity. Unlike EVs, hybrids don’t need to be plugged in for charging.
             
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
               Why should learn about Hybrid Electric Vehicles (HEVs)?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
                            Understanding HEVs prepares students for the fast-growing green automotive industry, where knowledge of hybrid systems, electric mobility, and sustainable technology is in high demand.

            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Why is Hybrid Electric Vehicle technology seen as a long-term career opportunity?
             
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
                           Because it is not only relevant today but also forms the foundation of future innovations in mobility, ensuring strong and lasting career prospects.

            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What career opportunities are available for students  in HEV?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
               There are various career opportunities in HEV, including:
            <ul>
              
                <li>Automotive Engineer</li>
               <li>EV Design Specialist</li>
               <li>Battery Technologist</li>
             <li>Sustainability Consultant</li>
             <li>R&D Engineer in automobile and energy companies</li>
          </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default HEV_FAQ_page
